import React from "react";
import style from "./../style.module.css";
import Link from "../../Link";
import formatUrl from "utils/FormatUrl";

function index({ lang, t }) {
  const links = [
    {
      value: t("Toutes les annonces"),
      linkTo: "/list.htm?transaction_type=vente",
      color: "#000",
    },
    {
      value: t("Immobilier Neuf"),
      linkTo: "/list.htm?transaction_type=projets-neufs",
      color: "#000",
    },
  ];

  const secondLinks = [
    {
      value: t("Le guide de l'acheteur au Maroc"),
      linkTo: "/acheter/guide",
      color: "#000",
    },
  ];
  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        <div className={style.firstLinksSection}>
          <p className={style.sectionTitle}>{t("Annonces")}</p>
          {links.map((item, key) => {
            return (
              <Link
                key={key}
                linkTo={formatUrl(item.linkTo, lang)}
                value={t(item.value)}
                isSubNav={false}
                fromSub={true}
                color={item.color}
                arrow={true}
              />
            );
          })}
        </div>
        <div className={style.secondLinksSection}>
          <p className={style.sectionTitle}>{t("Ressources")}</p>
          {secondLinks.map((item, key) => {
            return (
              <div className={style.link}>
                <Link
                  key={key}
                  linkTo={formatUrl(item.linkTo, lang)}
                  value={t(item.value)}
                  isSubNav={false}
                  fromSub={true}
                  color={item.color}
                  arrow={true}
                />
              </div>
            );
          })}
        </div>
        <div className={style.thirdSection}></div>
      </div>
    </div>
  );
}

export default index;
